import { call, put, select } from 'typed-redux-saga';
import * as selectors from '../selectors';
import * as DataActions from '../actions/data';
import { fetchCategoryTree, fetchCategory } from '../api/category';
import { fetchArticle } from '../api/article';
import { getLanguageId } from '../utils/globals';
import { getNow } from './utils';
export function* fetchCategoryTreeData() {
    const status = yield* select(selectors.categoryTree.fetchingStatus);
    if (status === 'has-fetched' || status === 'is-fetching')
        return;
    const languageId = yield* call(getLanguageId);
    const now = yield* call(getNow);
    try {
        yield* put(DataActions.Actions.categoryTreeRequestStart());
        const data = yield* call(fetchCategoryTree, languageId);
        yield* put(DataActions.Actions.categoryTreeRequestSuccess({
            languageId,
            now,
            data,
        }));
    }
    catch (error) {
        yield* put(DataActions.Actions.categoryTreeRequestFail());
        throw error;
    }
}
export function* fetchArticlePageData(articleId) {
    // Check to see if we already have the data.
    const article = yield* select(selectors.categoryTree.articleFull, articleId);
    if (article)
        return;
    const now = yield* call(getNow);
    const languageId = yield* call(getLanguageId);
    try {
        yield* put(DataActions.Actions.articlePageDataRequestStart({ articleId }));
        const data = yield* call(fetchArticle, articleId, languageId);
        yield* put(DataActions.Actions.articlePageDataRequestSuccess({
            articleId,
            now,
            languageId,
            data,
        }));
    }
    catch (error) {
        yield* put(DataActions.Actions.articlePageDataRequestFail({
            articleId,
        }));
        throw error;
    }
}
export function* fetchCategoryPageData(categoryId) {
    // Check to see if we already have the data.
    const category = yield* select(selectors.categoryTree.category, categoryId);
    if (category)
        return;
    const now = yield* call(getNow);
    const languageId = yield* call(getLanguageId);
    try {
        yield* put(DataActions.Actions.categoryPageDataRequestStart({ categoryId }));
        const data = yield* call(fetchCategory, categoryId, languageId);
        yield* put(DataActions.Actions.categoryPageDataRequestSuccess({
            categoryId,
            now,
            languageId,
            data,
        }));
    }
    catch (error) {
        yield* put(DataActions.Actions.categoryPageDataRequestFail({
            categoryId,
        }));
        throw error;
    }
}
//# sourceMappingURL=data.js.map